const sendMessageToTelegram = async (data: Visitor) => {
  const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
  const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;
  const telegramUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

  const response = await fetch(telegramUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId,
      text: formatMessage(data),
      parse_mode: 'HTML',
    }),
  });

  return await response.json();
};

const formatMessage = (data: Visitor) => {
  const name = data.firstName + ' ' + data.lastName;

  return `
    🔔<b>Guest Interested in Connecting with You</b>
    A guest is interested in connecting with you. Details are below:
    <pre>
    Name: ${name}
    Company: ${data.companyName}
    Title: ${data.position}
    Email: ${data.email}
    Topic: ${data.topic}
    </pre>
  `;
};

export { sendMessageToTelegram };
